import { createFileUploadMaxSizeState } from '../services';
import { FILE_UPLOAD_ALL_FILES_UPLOAD_START, FILE_UPLOAD_RETRY_FILES_UPLOAD_START } from '../actions';
export const fileUploadModalMaxSizeReducer = (state = createFileUploadMaxSizeState(), action) => {
    switch (action.type) {
        case FILE_UPLOAD_ALL_FILES_UPLOAD_START:
        case FILE_UPLOAD_RETRY_FILES_UPLOAD_START:
            return { maxVideoFileSize: action.payload.maxVideoFileSize };
        default:
            return state;
    }
};
//# sourceMappingURL=fileUploadModalMaxSizeReducer.js.map